import {Component, Input} from '@angular/core';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'em-text-indicator',
  imports: [TooltipModule],
  templateUrl: './text-indicator.component.html',
})
export class TextIndicatorComponent {
  @Input({required: true}) text?: string;
  @Input() tooltipText?: string;
  @Input() withTooltip = false;
}
